var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2997 0.710689C13.1129 0.523436 12.8592 0.418203 12.5947 0.418203C12.3302 0.418203 12.0766 0.523436 11.8897 0.710689L6.99973 5.59069L2.10973 0.700689C1.9229 0.513436 1.66924 0.408203 1.40473 0.408203C1.14021 0.408203 0.886558 0.513436 0.699727 0.700689C0.309727 1.09069 0.309727 1.72069 0.699727 2.11069L5.58973 7.00069L0.699727 11.8907C0.309727 12.2807 0.309727 12.9107 0.699727 13.3007C1.08973 13.6907 1.71973 13.6907 2.10973 13.3007L6.99973 8.41069L11.8897 13.3007C12.2797 13.6907 12.9097 13.6907 13.2997 13.3007C13.6897 12.9107 13.6897 12.2807 13.2997 11.8907L8.40973 7.00069L13.2997 2.11069C13.6797 1.73069 13.6797 1.09069 13.2997 0.710689Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose24Px);
export default __webpack_public_path__ + "static/media/close_24px.358735d0.svg";
export { ForwardRef as ReactComponent };